import Logo from "../../../assets/img/logo.png";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";

export default function AuthShell({ isDesktop, children }) {
	return (
		<div className="relative min-h-screen flex flex-col overflow-hidden bg-gradient-to-b from-[#EEF5FC] via-[#F0F6FC] to-[#E8F2FA]">
			<div
				className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.045]"
				aria-hidden
			>
				<img src={Logo} alt="" className="w-[min(480px,85vw)] max-w-none select-none" />
			</div>
			<div className="relative z-[1] flex min-h-screen flex-col">
				<Header isDesktop={isDesktop} />
				<main className="flex-1 w-full max-w-[560px] mx-auto px-4 py-6 sm:py-10 flex flex-col items-stretch justify-center gap-4">
					{children}
				</main>
				<Footer isDesktop={isDesktop} />
			</div>
		</div>
	);
}
